export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9487.62acc604.jpg";